
import React from "react";
import ShopifyModal from "../../../../../components/ShopifyModal";

const UpgradePlanModal = ({upgradeOpen,setUpgradeOpen}) => {
  return (
    <div className="novice_video_modal">
      <ShopifyModal id="novice-order-modal"
      size="large"
        open={upgradeOpen}
        onClose={() => setUpgradeOpen()}
      >
       <div className="plan_grade_content">
       <div className="novice_video_title">How to fulfill orders? </div>
       <div className="novice_video_modal_content">
       <iframe style={{borderRadius:'20px'}} title='dropshipman' src={'https://www.youtube.com/embed/1OiyRfrMF74?rel=0&autoplay=1&loop=1'} width="880" height="500" frameBorder="0" allowFullScreen="allowfullscreen" referrerpolicy="strict-origin-when-cross-origin" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>
       </div>
       </div>
      </ShopifyModal>
    </div>
  );
};

export default UpgradePlanModal;
